/**
 * What to say about a thrown value.
 *
 * `strict` implies `useUnknownInCatchVariables`, so every `catch (err)` binds
 * `unknown` — which is correct, and which the codebase had been opting out of
 * with `catch (err: any)` in 122 places. `err?.message` on an `any` is not a
 * check, it is a hope: a thrown string, a rejected fetch, or anything that is
 * not an Error yields `undefined`, and the template literal around it prints
 * the word "undefined" to a user or into a log.
 *
 * The `fallback` parameter is the whole reason this lives here rather than
 * being the client's one-argument helper: the server's catch blocks each carry
 * their OWN sentence ("blank deck creation failed", "import failed"), and 62 of
 * them say something more useful than a generic. Collapsing those into one
 * house string would lose the only part of the message that identifies which
 * operation broke.
 *
 * Lives in src/shared because both runtimes need it; `client/lib/api.ts`
 * re-exports it, so no client importer moved.
 */
export function errorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (err instanceof Error && err.message) return err.message;
  if (typeof err === 'string' && err) return err;
  return fallback;
}
